import axios from 'axios';
import { store } from '../../store.js';

const devUrl = 'http://10.10.1.21:4000/'
//개발 서버 http://10.10.1.21:4000/
//운영 서버 https://api.yoyangsys.co.kr/
const prodUrl = 'https://ct1.yoyangsys.co.kr/'

let remoteURL = ''
let remotePORT = 80
let remotePROTOCOL = 'http'

if(window.location.hostname.includes('yoyangsys.co.kr')){
    remoteURL = prodUrl
    remotePORT = 443
    remotePROTOCOL = 'https'
}
else{
    remoteURL = devUrl
    remotePORT = 80
    remotePROTOCOL = 'http'
}
// if (process.env.NODE_ENV == 'development') {
//     remoteURL = devUrl
//     remotePORT = 80
//     remotePROTOCOL = 'http'
// }
// else if (process.env.NODE_ENV == 'production'){
//     remoteURL = prodUrl
//     remotePORT = 443
//     remotePROTOCOL = 'https'
// }

const http = axios.create({
    baseURL: remoteURL,
    timeout: 0,
    withCredentials: false,
    headers: {
        'Access-Control-Allow-Origin': 'yoyangsys.co.kr',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Credentials': 'true',
    },
    proxy: {
        protocol: remotePROTOCOL,
        host: 'yoyangsys.co.kr',
        port: remotePORT,
    },
})

http.interceptors.request.use(
    (config) => {
        if(store.state.sessionInfo.tkn != ''){
            config.headers.token = store.state.sessionInfo.tkn
            config.headers.key = store.state.sessionInfo.key
        }
        return config;
    },
    (error) => {
        // 요청 에러 직전 호출됩니다.
        return Promise.reject(error)
    }
);

http.interceptors.response.use(
    (config) => {
        //console.log(config)
        return config;
    },
    (error) => {
        // 요청 에러 직전 호출됩니다.
        return Promise.reject(error)
    }
);

export{
    http, remoteURL
}
